import { Component, OnInit } from '@angular/core';
import { ApiServiceEnum } from 'src/app/helpers/enum';

@Component({
    selector: 'plan-fund-advice',
    templateUrl: './plan-fund-advice.component.html',
    styleUrl: './plan-fund-advice.component.css',
    standalone: false
})
export class PlanFundAdviceComponent implements OnInit {
  service = ApiServiceEnum.WILSHIRE_PLAN_ADV;

  ngOnInit(): void {}

}
